export default {
  SUGGEST_GET: 'ott/railways/getSuggest',
  SUGGEST_GET_SUCCESS: 'ott/railways/getSuggestSuccess',
  SUGGEST_GET_FAIL: 'ott/railways/getSuggestFail',
  SUGGEST_RESET: 'ott/railways/suggestReset',
  SUGGEST_CACHE: 'ott/railways/suggestCache',
};
